/* ==========================================================================
   Product page interactions
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Sticky gallery offset ----------------
     Keeps the sticky media column clear of the site header. If the header
     is using its own "sticky" option (section.settings.sticky in
     sections/header.liquid → .eeh-header--sticky), this measures its
     rendered height and feeds it back in as --sticky-gallery-top so the
     gallery doesn't stick underneath it. If the header isn't sticky, a
     small fixed gap is used instead. */
  function updateStickyGalleryOffset() {
    var header = document.getElementById('SiteHeader');
    var isHeaderSticky = header && window.getComputedStyle(header).position === 'sticky';
    var offset = (isHeaderSticky ? header.offsetHeight : 0) + 20;
    document.documentElement.style.setProperty('--sticky-gallery-top', offset + 'px');
  }
  if (document.querySelector('[data-product-media-sticky]')) {
    updateStickyGalleryOffset();
    window.addEventListener('resize', updateStickyGalleryOffset);
  }

  /* ---------------- Gallery ---------------- */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    function showSlide(mediaId) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === String(mediaId));
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(thumb.getAttribute('data-media-id'));
      });
    });

    function cycle(direction) {
      var activeIndex = 0;
      slides.forEach(function (slide, i) { if (slide.classList.contains('is-active')) activeIndex = i; });
      var nextIndex = (activeIndex + direction + slides.length) % slides.length;
      showSlide(slides[nextIndex].getAttribute('data-media-id'));
    }

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { cycle(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { cycle(1); });
  }

  /* ---------------- Variant picker ---------------- */
  var picker = document.querySelector('[data-variant-picker]');
  var productInfo = document.querySelector('[data-product-info]');

  if (picker && productInfo) {
    var variantJsonEl = picker.querySelector('[data-variant-json]');
    var variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : [];
    var nativeSelect = picker.querySelector('[data-variant-select]');

    function getSelectedOptions() {
      var options = [];
      picker.querySelectorAll('.product-variant-picker__option').forEach(function (optionEl) {
        var selected = optionEl.querySelector('.product-variant-picker__pill.is-selected');
        options.push(selected ? selected.getAttribute('data-option-value') : null);
      });
      return options;
    }

    function findMatchingVariant(options) {
      return variants.find(function (v) {
        return options.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      if (nativeSelect) nativeSelect.value = variant.id;
      var formInput = document.querySelector('[data-form-variant-id]');
      if (formInput) formInput.value = variant.id;

      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="product-section__price--sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="product-section__price--compare">' + formatMoney(variant.compare_at_price) + '</span>' +
            '<span class="product-card__badge product-card__badge--sale">Sale</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
        }
      }

      var submitBtn = document.querySelector('[data-add-to-cart-submit]');
      var submitText = document.querySelector('[data-submit-text]');
      if (submitBtn) submitBtn.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? (window.themeStrings && window.themeStrings.addToCart || 'Add to cart') : 'Sold out';

      var skuEl = document.querySelector('[data-product-sku]');
      if (skuEl && variant.sku) skuEl.textContent = 'SKU: ' + variant.sku;

      if (variant.featured_media) {
        var mediaId = variant.featured_media.id;
        var slide = document.querySelector('[data-gallery-slide][data-media-id="' + mediaId + '"]');
        if (slide) {
          document.querySelectorAll('[data-gallery-slide]').forEach(function (s) { s.classList.remove('is-active'); });
          document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          slide.classList.add('is-active');
          var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
          if (thumb) thumb.classList.add('is-active');
        }
      }

      updateStickyATC(variant);
    }

    function formatMoney(cents) {
      // Best-effort client-side formatting; server-rendered price on load is authoritative.
      var amount = (cents / 100).toFixed(2);
      return (window.themeMoneyFormat || '${{amount}}').replace('{{amount}}', amount);
    }

    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('.product-variant-picker__pill');
      if (!pill) return;
      var optionGroup = pill.closest('.product-variant-picker__values');
      optionGroup.querySelectorAll('.product-variant-picker__pill').forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-selected');
      pill.setAttribute('aria-pressed', 'true');
      var valueLabel = pill.closest('.product-variant-picker__option').querySelector('[data-selected-option-value]');
      if (valueLabel) valueLabel.textContent = pill.getAttribute('data-option-value');

      var variant = findMatchingVariant(getSelectedOptions());
      updateUI(variant);
    });
  }

  /* ---------------- Quantity stepper ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-decrease], [data-quantity-increase]');
    if (!btn) return;
    var stepper = btn.closest('[data-quantity-stepper]');
    var input = stepper && stepper.querySelector('[data-quantity-input]');
    if (!input) return;

    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var step = parseInt(input.getAttribute('step'), 10);
    if (isNaN(step) || step < 1) step = 1;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;

    var next = btn.hasAttribute('data-quantity-increase') ? current + step : current - step;
    if (next < min) next = min;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Buy Now (adds the item, then skips the cart drawer and goes straight to checkout) ---------------- */
  document.addEventListener('click', function (e) {
    var buyNowBtn = e.target.closest('[data-buy-now-submit]');
    if (!buyNowBtn) return;
    var form = buyNowBtn.closest('form[data-product-form]');
    if (!form || buyNowBtn.disabled) return;

    var variantInput = form.querySelector('[data-form-variant-id]');
    var qtyInput = form.querySelector('[data-quantity-input]');
    var variantId = variantInput ? variantInput.value : null;
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (!variantId) return;

    buyNowBtn.disabled = true;
    buyNowBtn.classList.add('button--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        buyNowBtn.disabled = false;
        buyNowBtn.classList.remove('button--loading');
        var message = (err && err.description) || 'This item is unavailable right now.';
        if (window.CartToast && window.CartToast.show) window.CartToast.show(message, { error: true });
      });
  });

  /* ---------------- Product tabs (Description / Specification / FAQs / Related products) ---------------- */
  var tabsWrap = document.querySelector('[data-product-tabs]');
  var tabTriggers = [];
  var tabPanels = [];
  var activateTab; // exposed to the recommendations block below

  if (tabsWrap) {
    tabTriggers = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-tab-trigger]'));
    tabPanels = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-tab-panel]'));

    activateTab = function (name) {
      tabTriggers.forEach(function (btn) {
        var isActive = btn.getAttribute('data-tab-trigger') === name;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      tabPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === name);
      });
    };

    if (tabTriggers.length) activateTab(tabTriggers[0].getAttribute('data-tab-trigger'));

    tabsWrap.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-tab-trigger]');
      if (!trigger) return;
      activateTab(trigger.getAttribute('data-tab-trigger'));
    });
  }

  /* ---------------- Sticky add-to-cart bar ---------------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var buyButtonsBlock = document.querySelector('[data-add-to-cart-submit]');

  function updateStickyATC(variant) {
    if (!stickyBar) return;
    var titleEl = stickyBar.querySelector('[data-sticky-title]');
    var priceEl = stickyBar.querySelector('[data-sticky-price]');
    if (titleEl && document.title) titleEl.textContent = document.querySelector('.product-section__title') ? document.querySelector('.product-section__title').textContent : '';
    if (priceEl && variant) priceEl.textContent = formatMoneyFallback(variant.price);
  }
  function formatMoneyFallback(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  if (stickyBar && buyButtonsBlock) {
    var sentinel = document.querySelector('[data-product-form]');
    if (sentinel && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(sentinel);
    }

    stickyBar.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-add]')) {
        buyButtonsBlock.click();
      }
    });
  }

  /* ---------------- Product recommendations (lazy-loaded section) ---------------- */
  var recommendations = document.querySelector('product-recommendations[data-url]');
  if (recommendations) {
    fetch(recommendations.getAttribute('data-url'))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var content = doc.querySelector('product-recommendations');
        if (content && content.innerHTML.trim()) {
          recommendations.innerHTML = content.innerHTML;
        }
      })
      .catch(function () {});
  }
})();